// services/supplier.service.ts
import { apiService } from "../../app.service";

export const supplierApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Fetch single supplier with location
    fetchSupplier: builder.query({
      query: ({ id, locationId }) => ({
        url: `/supplier/${id}${locationId ? `?locationId=${locationId}` : ''}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "supplier", id: result._id }] : [],
    }),

    // ✅ Fetch all suppliers with location
    fetchSupplieres: builder.query({
      query: (locationId) => {
        const params = locationId ? `?locationId=${locationId}` : '';
        return {
          url: `/supplier${params}`,
        };
      },
      providesTags: ["suppliers"],
    }),

    // ✅ Create supplier (location handled by backend)
    createSupplier: builder.mutation({
      query: (data) => ({
        url: "/supplier",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["suppliers"],
    }),

    // ✅ Update supplier with location
    updateSupplier: builder.mutation({
      query: ({ id, data, locationId }) => ({
        url: `/supplier/${id}${locationId ? `?locationId=${locationId}` : ''}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "supplier", id },
        "suppliers",
      ],
    }),

    // ✅ Delete supplier with location
    deleteSupplier: builder.mutation({
      query: ({ id, locationId }) => ({
        url: `/supplier/${id}${locationId ? `?locationId=${locationId}` : ''}`,
        method: "DELETE",
      }),
      invalidatesTags: ["suppliers"],
    }),
  }),
});

export const {
  useFetchSupplieresQuery,
  useFetchSupplierQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
  useDeleteSupplierMutation,
} = supplierApi;